module.exports = __webpack_public_path__ + "images/emoji/tada.0ab534126078f5966dc4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tada.png
// module id = aEZI
// module chunks = 14